<template>
  <div>
    <section class="">
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
            <div class="container">
                <ol class="breadcrumb hidden-xs">
					<li><a href="/">首頁</a></li>
					<li><a href="/news">最新消息</a></li>
					<li class="active">內容</li>
				</ol>
                <div class="row">
                    <div class="col-sm-2">
                        <div class="aside_menu">
                            <h4 class="title">最新消息</h4>
                            <ul class="list-unstyled">
                                <li class="active item"><a href="">主要消息</a></li>
                                <li class="item"><a href="">活動消息</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-10">
                        <div class="new_list">
                            <div class="news_box" v-for="(row, index) in news">
                                <div class="date">
                                    <span class="day">{{row.c_date | formatDate}}</span>
                                    <span class="month">{{row.c_date | formatMonth}}月</span>
                                </div>
                                <h5 class="title">{{row.c_title}}</h5>
                                <p class="txt">
                                    {{row.c_content | truncate(200) }}
                                    <router-link v-bind:to="'/news/'+index" class="pull-right more">
                                    了解更多<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
                                    </router-link>
                                </p>
                            </div>
                        </div>
                        <nav aria-label="...">
                            <ul class="pagination">
                                <li class="disabled">
                                    <a href="#" aria-label="Previous">
                                        <span aria-hidden="true">&laquo;</span>
                                    </a>
                                </li>
                                <li class="active"><a href="#">1 <span class="sr-only">(current)</span></a></li>
                                <!--
                                <li class=""><a href="#">2 <span class="sr-only"></span></a></li>
                                -->
                                <li class="disabled">
                                    <a href="#" aria-label="Next">
                                        <span aria-hidden="true">&raquo;</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'News',
  data () {
    return {
      news: {}
    }
  },
  created () {
  },
  mounted: function () {
    let news = window.localStorage.getItem('news')
    this.news = JSON.parse(news)
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ])
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  },
  filters: {
    formatDate: function (date) {
      return moment(date).format('DD')
    },
    formatMonth: function (date) {
      return moment(date).format('MM')
    },
    truncate: function (string, value) {
      let str = string.replace(/<\/?[^>]+(>|$)/g, '')
      return str.substring(0, value) + '...'
    }
  }
}
</script>



// WEBPACK FOOTER //
// News.vue?0935f540